var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 582 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M180.416 32.398c-.718.036-16.782.792-36.635-6.195-2.439-.859-4.975-1.897-7.426-2.902-14.879-6.095-27.729-11.358-37.246 9.098-2.735 5.879-4.819 11.379-6.657 16.232-6.711 17.714-17.089 37.643-40.349 37.643-20.924 0-54.322-21.875-54.322-21.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M180.121 26.405c-.164.01-15.659.715-34.348-5.863-2.296-.808-4.651-1.772-7.144-2.794-14.714-6.026-33.027-13.529-44.961 12.119-2.828 6.079-4.753 11.769-6.828 16.638-7.121 16.713-15.767 33.978-35.26 33.978-17.024 0-53.801-22.842-53.801-22.842M395.642 32.068c.137-.009 13.73-.759 31.718 6.979l1.801.781c7.25 3.155 17.733 7.718 29.065 7.718 10.552 0 21.842-3.958 31.938-16.692 18.418-23.233 30.167-23.229 34.845-23.229 17.309 0 53.176 20.475 58.374 37.975"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M395.248 26.081c.606-.041 15.074-.895 34.482 7.454l1.824.791c14.271 6.21 35.835 15.595 53.907-7.201 20.208-25.49 33.647-25.419 39.547-25.505 14.883-.217 43.646 13.31 58.374 32.622"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red",
    d: "M283.667 11.387c10.493 0 19 8.507 19 19s-8.507 19-19 19-19-8.507-19-19 8.507-19 19-19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red_compl",
    d: "M293.192 36.382c.4.39.4 1.02.01 1.42h-.01l-2.12 2.12a.996.996 0 01-1.41 0l-6-6-6 6a.996.996 0 01-1.41 0l-2.12-2.13a.996.996 0 010-1.41l6-6-6-6a.996.996 0 010-1.41l2.12-2.12a.996.996 0 011.41 0l6 6 6-6a.996.996 0 011.41 0h.01l2.12 2.12c.39.39.39 1.02 0 1.41l-6 6.01 5.99 5.99z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M369.909 49.581h-10.304V9.493h10.304c11.063 0 20.044 8.981 20.044 20.044s-8.981 20.044-20.044 20.044zM392.524 34.625h-2.571V24.448h2.571a3.01 3.01 0 013.008 3.008v4.162a3.01 3.01 0 01-3.008 3.008zM332.753 15.934h18.369v5.917h-18.369a2.96 2.96 0 01-2.959-2.959 2.96 2.96 0 012.959-2.959zM332.753 37.222h18.369v5.917h-18.369a2.96 2.96 0 01-2.959-2.959 2.96 2.96 0 012.959-2.959zM205.908 9.492h10.304V49.58h-10.304c-11.063 0-20.044-8.981-20.044-20.044s8.981-20.044 20.044-20.044z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M183.293 24.448h2.571v10.177h-2.571a3.01 3.01 0 01-3.008-3.008v-4.162a3.01 3.01 0 013.008-3.008z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "SI_4L_stroke",
    x: 351.121,
    y: 5.482,
    width: 8.484,
    height: 48.11,
    rx: 4.219,
    ry: 4.219,
    transform: "rotate(180 355.363 29.537)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "SI_4L_stroke",
    x: 216.213,
    y: 5.482,
    width: 8.484,
    height: 48.11,
    rx: 4.219,
    ry: 4.219
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/connectionError.adc19a3f0f87340af6719a9138d5db89.svg";
export { ForwardRef as ReactComponent };